{
    "CallsansweredwithinLabel": "Calls Should Be Answered Within:",
    "CallsansweredwithinPlaceholder": "10",
    "CallsansweredwithinUnit": "s",
    "NAME": "ServiceLvlSettings",
    "ServiceLvlSettings_SectionHeader": "Service Level Settings",
    "ServiceLvlSettings_SectionPara": "You can adjust the following settings to specifically control how the current report calculates the \"% Service Level\" statistic when it is supported by the chosen report style and is also selected for display.",
    "ServiceLvlSettings_IgnorequickabndcallswithinLabel": "Ignore Quick Abandoned Calls Within:",
    "ServiceLvlSettings_IgnorequickabndcallswithinPlaceholder": "5",
    "ServiceLvlSettings_IgnorequickabndcallswithinEnabledHiddenlabel": "Is \"Ignore Quick Abandoned Calls Within\" Setting Enabled?",
    "ServiceLvlSettings_IgnorequickabndcallswithinUnit": "s",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinLabel": "Ignore Overflowed Calls Within:",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinPlaceholder": "5",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinEnabledHiddenlabel": "Is \"Ignore Overflowed Calls Within\" Setting Enabled?",
    "ServiceLvlSettings_IgnoreovrflwdcallswithinUnit": "s"
}